import * as types from '@types'
import * as services from '@services/personalInfo'
import { getForeign, updateForeign } from '@services/personalInfoForeign'
import { getHandicap, updateHandicap, deleteHandicap } from '@services/personalInfoHandicap'

export default {
  state: {
    personal: {},
    systemFields: {},
    foreign: {},
    handicap: {},
    customFields: {}
  },

  getters: {
    [types.EMPLOYEE_PERSONAL_INFO]: state => ({ ...state.personal })
  },

  mutations: {
    [types.EMPLOYEE_UPDATE_PERSONAL]: (state, data) => {
      state.personal = { ...state.personal, ...data }
    },

    [types.EMPLOYEE_UPDATE_NATIONALITIES]: (state, nationalities) => {
      state.personal = { ...state.personal, nationalities }
    },

    [types.EMPLOYEE_UPDATE_FOREIGN]: (state, data) => {
      state.foreign = { ...state.foreign, ...data }
    },

    [types.EMPLOYEE_UPDATE_HANDICAP]: (state, data) => {
      state.handicap = { ...data }
    },

    [types.EMPLOYEE_PERSONAL_SYSTEM_FIELDS]: (state, data) => {
      state.systemFields = { ...(data?.systemFields || {}) }
      state.customFields = { ...(data?.customFields || {}) }
    }
  },

  actions: {
    [types.EMPLOYEE_PERSONAL_INFO]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await services.getPersonal({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_PERSONAL, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_GET_NATIONALITIES]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, nationalities ] = await services.getNationalities({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_NATIONALITIES, nationalities)

      return [ err, nationalities ]
    },

    [types.EMPLOYEE_GET_HANDICAP]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await getHandicap({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_HANDICAP, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_GET_FOREIGN]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await getForeign({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_FOREIGN, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_PERSONAL_SYSTEM_FIELDS]: async ({ commit, getters }) => {
      const [ err, data ] = await services.getCustomFields(getters)

      if (!err) commit(types.EMPLOYEE_PERSONAL_SYSTEM_FIELDS, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_UPDATE_PERSONAL]: async ({ state, getters, commit }, data) => {
      const schema = state.customFields?.personal || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, personal ] = await services.updatePersonal(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_PERSONAL, personal)

      return [ err, personal ]
    },

    [types.EMPLOYEE_UPDATE_EMPLOYEE]: async ({ getters }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err ] = await services.updateEmployee(data, { companyId, employeeId })

      return [ err ]
    },

    [types.EMPLOYEE_UPDATE_NATIONALITIES]: async ({ getters }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, nationalities ] = await services.updateNationalities(
        data,
        { companyId, employeeId }
      )

      return [ err, nationalities ]
    },

    [types.EMPLOYEE_UPDATE_FOREIGN]: async ({ state, getters, commit }, data) => {
      const schema = state.customFields?.foreign || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, foreign ] = await updateForeign(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_FOREIGN, foreign)

      return [ err, foreign ]
    },

    [types.EMPLOYEE_UPDATE_HANDICAP]: async ({ state, commit, getters }, data) => {
      const schema = state.customFields?.handicap || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, handicap ] = await updateHandicap(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_HANDICAP, handicap)

      return [ err, handicap ]
    },

    [types.EMPLOYEE_DELETE_HANDICAP]: async ({ getters, commit }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }

      const [ err ] = await deleteHandicap(params)

      if (!err) commit(types.EMPLOYEE_UPDATE_HANDICAP, { hasDeficiency: false })

      return [ err, data ]
    },
  }
}
